var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FFC427"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C12.2232 9 12.4194 9.14799 12.4808 9.36264L13.0229 11.2601C13.2602 12.0906 13.9094 12.7398 14.7399 12.9771L16.6374 13.5192C16.852 13.5806 17 13.7768 17 14C17 14.2232 16.852 14.4194 16.6374 14.4808L14.7399 15.0229C13.9094 15.2602 13.2602 15.9094 13.0229 16.7399L12.4808 18.6374C12.4194 18.852 12.2232 19 12 19C11.7768 19 11.5806 18.852 11.5192 18.6374L10.9771 16.7399C10.7398 15.9094 10.0906 15.2602 9.2601 15.0229L7.36264 14.4808C7.14799 14.4194 7 14.2232 7 14C7 13.7768 7.14799 13.5806 7.36264 13.5192L9.2601 12.9771C10.0906 12.7398 10.7398 12.0906 10.9771 11.2601L11.5192 9.36264C11.5806 9.14799 11.7768 9 12 9Z",
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18.2294 7 18.4294 7.15615 18.4851 7.37873L18.6576 8.06904C18.8144 8.69604 19.304 9.1856 19.931 9.34235L20.6213 9.51493C20.8439 9.57057 21 9.77057 21 10C21 10.2294 20.8439 10.4294 20.6213 10.4851L19.931 10.6576C19.304 10.8144 18.8144 11.304 18.6576 11.931L18.4851 12.6213C18.4294 12.8439 18.2294 13 18 13C17.7706 13 17.5706 12.8439 17.5149 12.6213L17.3424 11.931C17.1856 11.304 16.696 10.8144 16.069 10.6576L15.3787 10.4851C15.1561 10.4294 15 10.2294 15 10C15 9.77057 15.1561 9.57057 15.3787 9.51493L16.069 9.34235C16.696 9.1856 17.1856 8.69604 17.3424 8.06904L17.5149 7.37873C17.5706 7.15615 17.7706 7 18 7Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16C17.2152 16 17.4063 16.1377 17.4743 16.3419L17.7372 17.1304C17.8367 17.429 18.071 17.6633 18.3696 17.7628L19.1581 18.0257C19.3623 18.0937 19.5 18.2848 19.5 18.5C19.5 18.7152 19.3623 18.9063 19.1581 18.9743L18.3696 19.2372C18.071 19.3367 17.8367 19.571 17.7372 19.8696L17.4743 20.6581C17.4063 20.8623 17.2152 21 17 21C16.7848 21 16.5937 20.8623 16.5257 20.6581L16.2628 19.8696C16.1633 19.571 15.929 19.3367 15.6304 19.2372L14.8419 18.9743C14.6377 18.9063 14.5 18.7152 14.5 18.5C14.5 18.2848 14.6377 18.0937 14.8419 18.0257L15.6304 17.7628C15.929 17.6633 16.1633 17.429 16.2628 17.1304L16.5257 16.3419C16.5937 16.1377 16.7848 16 17 16Z",
    fill: "#F59E0B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "#FBBF24",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.f115bd543a4c3fbe231991fecb6e218e.svg";
export { ForwardRef as ReactComponent };